import type { RundownCueOrderItem } from '@rundown-studio/types'

type CueItem = RundownCueOrderItem

// Tree manipulation utilities
export const removeCueFromTree = (
  items: CueItem[],
  itemId: string,
): CueItem | null => {
  for (let i = 0; i < items.length; i++) {
    if (items[i].id === itemId) {
      return items.splice(i, 1)[0]
    }

    const children = items[i].children
    if (children) {
      const removed = removeCueFromTree(children, itemId)

      if (removed) return removed
    }
  }
  return null
}

export const insertCueInTree = (
  items: CueItem[],
  targetId: string,
  item: CueItem,
  insertAfter: boolean = false,
): boolean => {
  for (let i = 0; i < items.length; i++) {
    if (items[i].id === targetId) {
      const insertIndex = insertAfter ? i + 1 : i
      items.splice(insertIndex, 0, item)
      return true
    }

    const children = items[i].children
    if (children) {
      if (insertCueInTree(children, targetId, item, insertAfter)) {
        return true
      }
    }
  }
  return false
}

export const addCueToGroup = (
  items: CueItem[],
  groupId: string,
  itemId: string,
): boolean => {
  const groupIndex = items.findIndex((cue) => cue.id === groupId)

  if (groupIndex === -1) return false

  if (!items[groupIndex].children) {
    items[groupIndex].children = []
  }

  items[groupIndex].children.unshift({ id: itemId })

  return true
}

export const moveCueToGroup = (
  cues: CueItem[],
  sourceCueId: string,
  groupId: string,
): CueItem[] => {
  const draggedItem = removeCueFromTree(cues, sourceCueId)

  if (!draggedItem) return cues

  const success = addCueToGroup(cues, groupId, sourceCueId)

  if (!success) {
    console.error('Failed to find target group')
  }

  return cues
}

export const reorderCues = (
  cues: CueItem[],
  sourceCueId: string,
  targetCueId: string,
  insertAfter: boolean = false,
): CueItem[] => {
  const draggedItem = removeCueFromTree(cues, sourceCueId)

  if (!draggedItem) return cues

  const isInserted = insertCueInTree(
    cues,
    targetCueId,
    draggedItem,
    insertAfter,
  )

  if (!isInserted) {
    console.error('Failed to find target position')
  }

  return cues
}
